import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';

export const ColumnLabelsInSnowflake: FC = () => {
  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="column_labels_in_snowflake"
      headerTitle="Column Labels in Snowflake"
      body={
        <Stack spacing={10}>
          <Text>
            Ariksa automatically identities and classifies sensitive data
            present in database columns for every table, schema and database. We
            use Snowflake’s native capabilities to mask data based on persona
            and policies assigned to them.
          </Text>
          <Text>
            Labels provide an effective way to dynamically mask sensitive data
            when authorized users access present in Snowflake database. Labels
            or tags applied to databases can be uniquely associated with only a
            single masking policy. In other words, Snowflake does not allow use
            of different masking policies for the same tag or labels. You can
            however set different masking policies based on Snowflake data types
            such as string, numbers and dates.
          </Text>
        </Stack>
      }
    />
  );
};
